<div class="modal-header">
  <h4 class="modal-title pull-left"> Feedback / Help </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <div class="row">
    <span class="label">User: </span>
    <div class="text">{{details?.USER.getName()}}</div>
  </div>

  <div class="row">
    <span class="label">Date: </span>
    <div class="text">{{details?.DATE | date: 'long'}} </div>
  </div>

</div>

<div class="container">
  <form name="form" #f="ngForm" class="form">
    <div class="form-group">
      <label>Comments / Notes to Developer:</label>
      <textarea name="comments" [(ngModel)]="comments" class="form-control rounded-0" rows="6"
        style="resize: none;"></textarea>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button type="button" class="btn btn-rbv" (click)="onConfirm()">
    Send
  </button>
</div>